'use client';

import {
  RequestRateLimitSettingsCard,
  toasterApi,
} from '@terra/ui-design-system';
import { useTranslations } from 'next-intl';
import { useCallback } from 'react';
import { useApplicationById } from '../../hooks/api/useApplicationById';
import { useUpdateApplicationFields } from '../../hooks/api/useUpdateApplicationFields';

type RequestRateLimitCardProps = {
  applicationId: string;
  isReadOnly?: boolean;
};

export function RequestRateLimitCard({
  applicationId,
  isReadOnly,
}: RequestRateLimitCardProps) {
  const tSettings = useTranslations('settings');
  const { application } = useApplicationById({ id: applicationId });
  const { mutateAsync, isPending } = useUpdateApplicationFields();

  const handleCommit = useCallback(
    async (next: number | null) => {
      try {
        await mutateAsync({
          applicationId,
          body: { targetRequestsPerMinute: next },
        });

        return true;
      } catch (error: unknown) {
        toasterApi.error({
          title: tSettings('saveFailed'),
          description:
            error instanceof Error && error.message.length > 0
              ? error.message
              : undefined,
        });

        return false;
      }
    },
    [applicationId, mutateAsync, tSettings],
  );

  return (
    <RequestRateLimitSettingsCard
      value={application?.targetRequestsPerMinute}
      disabled={Boolean(isReadOnly) || isPending}
      onCommit={handleCommit}
    />
  );
}
